import React from "react"
import Utils from "../../utilities/Utils";
import { FormSectionElements } from "../../entities/formTemplateDataType";

interface Props {
    field:FormSectionElements;
    isEng: boolean;
    callbackElement
}

export class CustomErrorAlertsComponent extends React.Component<Props> {
 HtmlToReactParser = require('html-to-react').Parser;
    constructor(props: Props) {
        super(props);
        
        this.props.field.Visible=false;
    }

    generateHtmlString = () => {
        let html = [];
        let errorMsgBulletPointHtml = [];
        const field = this.props.field;
       
        const htmlToReactParser = new this.HtmlToReactParser();
        errorMsgBulletPointHtml.push(htmlToReactParser.parse(this.props.isEng? field.ErrorMessageRichText: field.ErrorMessageRichTextFRA));
        
        html.push(
            <div className="ontario-alert ontario-alert--error callout-max-width" role="alert" tabIndex={-1} id="error-container" >
                <div className="ontario-alert__header">
                    <div className="ontario-alert__header-icon">
                        <svg className="ontario-icon" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#cd0000" />
                            <path d="M11 17h2v-2h-2v2zm0-4h2V7h-2v6z" fill="#fff" />
                            <use href="#ontario-icon-alert-error"></use>
                        </svg>
                    </div>
                    <h2 className="ontario-alert__header-title ontario-h4">{this.props.isEng ? field.ENUTitle : field.FRATitle}</h2>
                </div>
                <div className="ontario-alert__body">
                    {errorMsgBulletPointHtml}
                </div>
            </div>
        );
        
        return html;
    }


    render() {
       return (
            this.props.field.Visible && this.generateHtmlString()
        )
    }
}
